import { Edit, SimpleForm, BooleanInput, TextInput, ReferenceInput, RadioButtonGroupInput, SelectInput } from 'react-admin';

const type = [
    { id: 'P', name: 'Code Action' },
    { id: 'S', name: 'Code Gestion' },
];

export const TagEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <BooleanInput source="active" />
            <RadioButtonGroupInput source="type" row choices={type} />
            <TextInput source="code" />
            <TextInput source="name" label="Nom" />
            <TextInput source="operation" label="Groupe d’actions" />
            <ReferenceInput source="program_id" reference="programs" label="Programme" link={false}>
                <SelectInput optionText={record => `${record.name}`} />
            </ReferenceInput>
            <ReferenceInput 
                source="manager"
                reference="users"
                label="Gestionnaire groupe d'actions"
                link={false}
                filter={{
                    active: true
                }}
                sort={{
                    field: 'prenom',
                    order: 'ASC',
                }}
                allowEmpty
            >
                <SelectInput optionText={record => `${record.prenom} ${record.nom}`} />
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);
